<template>
    <MainContent title="Compañia">
        <template v-slot:header>
            <h4 class="pt-1">Datos fiscales personalizados para el evento:</h4>
            <div class="card-tools mb-2">
                <router-link :to="{ name: 'back.compania-eventos.crear' }" class="btn btn-primary" id="crear-compania">
                    Crear compañia
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <div class="col-12">
                <b-tabs v-model="activeTab">
                    <b-tab title="Entradas">
                        <ContentOrLoading>
                            <CompaniaEntradas v-if="activeTab === 0" :key="reload" :evento="evento" @actualizar="getEvento(evento_id)"/>
                        </ContentOrLoading>
                    </b-tab>
                    <b-tab title="Productos">
                        <ContentOrLoading>
                            <CompaniaProductos v-if="activeTab !== 0" :key="reload" :evento="evento" @actualizar="getEvento(evento_id)"/>
                        </ContentOrLoading>
                    </b-tab>
                </b-tabs>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import CompaniaEntradas from "../../../components/backend/eventos/compania/CompaniaEntradas.vue";
    import CompaniaProductos from "../../../components/backend/eventos/compania/CompaniaProductos.vue";

    export default {
        props: ['evento_id'],
        data() {
            return {
                evento: null,
                email: '',
                activeTab: 0,
                reload: 1
            }
        },
        created() {
            this.getEvento(this.evento_id)
        },
        methods: {
            getEvento(evento_id) {
                const data = {
                    evento_id: evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), data).then(res => {
                    this.evento = res.data.data;
                    this.reload++
                });
            },
        },
        components: {
            MainContent, CompaniaEntradas, CompaniaProductos
        }
    }
</script>
